import { LoadingState } from './loading-state';

export const LOADING_INITIAL_STATE: LoadingState = {
  loading: false,
  error: null,
  success: false,
};
